export enum WidgetType {
    Chat = 'chat',
    Form = 'form',
    Button = 'button',
}

export const widgetTypeToWidgetLabel = (widgetType: WidgetType): string => {
    switch (widgetType) {
        case WidgetType.Chat: {
            return 'Chat';
        }
        case WidgetType.Form: {
            return 'Form';
        }
        case WidgetType.Button: {
            return 'Button';
        }
    }
};
